import React, {useMemo} from 'react';
import { LineViewContainer } from './LineView.elements';
import { ProteinView } from './protein/ProteinView';
import { LinePageHeader } from './components/LinePageHeader/LinePageHeader';

export const LineView = (): JSX.Element => {
  return (
    <LineViewContainer className="line-view-container">
      <LinePageHeader />
      <PageRoutes />
    </LineViewContainer>
  );
};

const PageRoutes = () => {

  // The business unit information is not returned by the Line API call.
  // Currently, only the 'protein' business unit supports the line view, so 'protein' is assigned by default.
  // To support other business units, the business unit information needs to be fetched from the Lines/lineId API.
  // This requires a backend change to include the business unit information in the API response.
  
  let businessUnit = 'protein';
  // cache the route
  const CachedRoute = useMemo(() => {
    if (businessUnit === 'pemea') businessUnit = 'protein';

    switch(businessUnit) {
      case 'protein':
        return <ProteinView />;
      default:
        return <div>MachineView 404: invalid business unit in MachineView PageRoutes</div>;
    }
  }, [businessUnit]);

  return CachedRoute;
};
